/**
 * AI model catalog. The backend whitelists by provider prefix
 * (anthropic/, openai/, google/, meta-llama/) so any model id in those
 * namespaces will pass — but we curate a short list here for the dropdown
 * so users get good defaults instead of pasting random model ids.
 *
 * Update this list when new flagship models ship.
 */

export interface AiModel {
  id: string;          // OpenRouter model id
  label: string;       // UI label
  provider: 'anthropic' | 'openai' | 'google';
  family: string;      // Group key for dropdown sections
  /** Optional short marketing tagline. */
  hint?: string;
}

export const AI_MODELS: AiModel[] = [
  // Anthropic
  { id: 'anthropic/claude-3.5-sonnet', label: 'Claude 3.5 Sonnet', provider: 'anthropic', family: 'Claude', hint: 'Default — balanced' },
  { id: 'anthropic/claude-3.5-haiku',  label: 'Claude 3.5 Haiku',  provider: 'anthropic', family: 'Claude', hint: 'Fast & cheap' },
  { id: 'anthropic/claude-3-opus',     label: 'Claude 3 Opus',     provider: 'anthropic', family: 'Claude', hint: 'Most capable (legacy)' },

  // OpenAI
  { id: 'openai/gpt-4o',         label: 'GPT-4o',         provider: 'openai', family: 'GPT', hint: 'Flagship' },
  { id: 'openai/gpt-4o-mini',    label: 'GPT-4o mini',    provider: 'openai', family: 'GPT', hint: 'Fast & cheap' },
  { id: 'openai/o1-mini',        label: 'o1-mini',        provider: 'openai', family: 'GPT', hint: 'Reasoning' },

  // Google
  { id: 'google/gemini-2.0-flash-exp', label: 'Gemini 2.0 Flash', provider: 'google', family: 'Gemini', hint: 'Experimental' },
  { id: 'google/gemini-pro-1.5',       label: 'Gemini Pro 1.5',   provider: 'google', family: 'Gemini' },
];

export const DEFAULT_MODEL = AI_MODELS[0].id;

export function modelById(id: string): AiModel | undefined {
  return AI_MODELS.find((m) => m.id === id);
}

export function modelsByFamily(): Map<string, AiModel[]> {
  const map = new Map<string, AiModel[]>();
  for (const m of AI_MODELS) {
    const list = map.get(m.family) ?? [];
    list.push(m);
    map.set(m.family, list);
  }
  return map;
}
